import { styled } from "styled-components";

/**
 * 공용 액션 버튼.
 *
 * 상태는 네이티브 `disabled` 속성으로 제어하므로 별도 prop이 DOM으로 새지 않는다.
 * - 활성(기본): 흰 배경 + 파란 테두리(#0079E0) + 검은 텍스트, 커서 pointer
 * - 활성 + hover: 파란 배경 + 흰 텍스트
 * - 비활성(disabled): 회색 텍스트/테두리, 커서 not-allowed
 *
 * 사용 예) <ActionButton disabled={선택없음} onClick={...}>게시 종료</ActionButton>
 * 페이지별로 크기 등을 더 손봐야 하면 styled(ActionButton)으로 확장한다.
 */
export const ActionButton = styled.button`
  height: 36px;
  min-width: 79px;
  padding: 0 16px;
  background: #ffffff;
  border-radius: 5px;
  text-align: center;
  font-family: "Noto Sans KR";
  font-style: normal;
  font-size: ${(props) => props.theme.Web_fontSizes.Body2};
  font-weight: ${(props) => props.theme.fontWeights.Body2};
  line-height: ${(props) => props.theme.LineHeight.Body2};
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  color: ${(props) => (props.disabled ? "#cfd4d9" : "#000000")};
  border: 1px solid ${(props) => (props.disabled ? "#e8e8e8" : "#0079e0")};
  transition:
    background-color 0.15s ease,
    color 0.15s ease,
    border-color 0.15s ease;

  &:not(:disabled):hover {
    background: #0079e0;
    color: #ffffff;
  }
`;

export default ActionButton;
